import PropTypes from "prop-types";
import React from "react";

import i18n from "@swa-ui/locale";

const REQUIRED_INDICATOR = "*";

export const RequiredIndicator = (props) => {
  const { className } = props;

  return (
    <div className={className}>
      <span aria-hidden="true">{REQUIRED_INDICATOR}</span>
      {i18n("RequiredIndicator__REQUIRED_INDICATOR_LABEL")}
    </div>
  );
};

RequiredIndicator.propTypes = {
  /** style to be applied to the component.  */
  className: PropTypes.string,
};
